import type { WebsiteHeaderPhotoSchema_PhotoSliderPageWidth } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_SLIDER_PAGE_WIDTH_DEFAULT: WebsiteHeaderPhotoSchema_PhotoSliderPageWidth = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSliderPageWidth-v1_0_0.json',
  presentationLayout: 'photoSliderPageWidth',
  photos: [],
};
